<template>
  <div class="card">
    <div class="card-body d-flex justify-content-between">
      <div>
        <span class="fa-stack fa-2x">
          <i :class="['fas fa-circle fa-stack-2x text-' + variant]"></i>
          <i :class="['fas', icon, 'fa-stack-1x fa-inverse text-white']"></i>
        </span>
      </div>
      <div class="text-right d-flex flex-column justify-content-between">
        <small class="text-black">{{ title }}</small>
        <h4 class="mb-0">{{ value | decimal }}</h4>
      </div>
    </div>
  </div>
</template>

<script>

import Filters from "./../../../mixins/Filters.js"

export default {
  props : {
    title : {

    },
    value : {

    },

    icon : {

    },

    variant : {
      default : 'primary'
    }
  }
};
</script>

<style>
</style>
